import React from 'react';

function KAnonymityNotice() {
  return (
    <div style={styles.notice} role="status">
      <span style={styles.text}>
        🔒 Insufficient participants (minimum 10 required for this metric)
      </span>
    </div>
  );
}

const styles = {
  notice: {
    backgroundColor: '#fef3c7',
    border: '1px solid #fcd34d',
    borderRadius: '8px',
    padding: '10px 14px',
    fontSize: '13px',
    color: '#92400e',
    fontWeight: '500',
  },
  text: {
    lineHeight: 1.4,
  },
};

export default KAnonymityNotice;
